/** The small pieces the session page and the VR menu both offer: a slider, a choice and a line of text. */
import { useEffect, useState } from "react";

export function Slider({ label, value, min, max, step, format, onInput, onCommit, disabled }: {
  label: string; value: number; min: number; max: number; step: number;
  format: (v: number) => string;
  onInput: (v: number) => void; onCommit: (v: number) => void; disabled?: boolean;
}) {
  return (
    <div className="field">
      <label>
        <span>{label}</span>
        <span className="v">{format(value)}</span>
      </label>
      <input type="range" min={min} max={max} step={step} value={value} disabled={disabled}
             onChange={(e) => onInput(Number(e.target.value))}
             onPointerUp={(e) => onCommit(Number((e.target as HTMLInputElement).value))}
             onKeyUp={(e) => onCommit(Number((e.target as HTMLInputElement).value))} />
    </div>
  );
}

/** A line of text that is only sent when it is saved (Enter or the button), never per keystroke. */
export function TextSetting({ label, value, placeholder, onSave, disabled }: {
  label: string; value: string; placeholder?: string;
  onSave: (v: string) => void; disabled?: boolean;
}) {
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);
  const changed = draft.trim() !== "" && draft.trim() !== value;
  return (
    <form className="field" onSubmit={(e) => { e.preventDefault(); if (changed) onSave(draft.trim()); }}>
      <label><span>{label}</span></label>
      <div className="text-setting">
        <input type="text" value={draft} placeholder={placeholder} disabled={disabled} maxLength={160}
               onChange={(e) => setDraft(e.target.value)} />
        <button type="submit" disabled={disabled || !changed}>Save</button>
      </div>
    </form>
  );
}

export function Choice<T extends string>({ label, value, options, onChange, disabled }: {
  label: string; value: T; options: { value: T; label: string }[];
  onChange: (v: T) => void; disabled?: boolean;
}) {
  return (
    <div className="field">
      <label><span>{label}</span></label>
      <div className="segmented">
        {options.map((option) => (
          <button key={option.value} type="button" disabled={disabled}
                  aria-pressed={option.value === value}
                  onClick={() => onChange(option.value)}>
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
